import script from "./FilialCertificadoModal.vue?vue&type=script&setup=true&lang=js"
export * from "./FilialCertificadoModal.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__